<template>
    <div>
        <!-- <mt-field :label="model.caption" :readonly="param.readonly" :value="displayValue" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign">
        </mt-field> -->
        <mt-cell :title="model.caption" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <div class="em-select-value mt-color-grey-lv3">
                <template>{{displayValue?displayValue:value}}</template>
            </div>
        </mt-cell>
        <mt-cell :title="model.caption" :disabledcolor="param.disabled" is-link :required="param.required" v-if="!param.readonly" @click.native="handleDisplayClick" :titlewidth="titlewidth" :value-align="textalign">
            <span :class="[{'mt-color-grey-lv3':displayValue ==='请选择' }]">{{displayValue?displayValue:value}}</span>
        </mt-cell>
        <bs-transition-page v-if="!param.readonly" v-model="selectorShow">
            <mt-search v-model="searchKey" :placeholder="placeholder"></mt-search>
            <mt-box-group v-model="currentValue" :style="{overflow: 'auto', height:radiolistHeight+'px'}">
                <mt-cell-group>
                    <mt-radiobox :name="item[valueMember]" :disabled="item.disabled" :key="item[valueMember]" v-for="item in options" @change.native="handleClickSelect(item)">{{item[displayMember]}}</mt-radiobox>
                </mt-cell-group>
            </mt-box-group>
        </bs-transition-page>
    </div>
</template>
<script>
import bsTransitionPage from '../baseComponents/bsTransitionPage.vue';
import { debounce, queryData } from '../formUtils.js';
export default {

    name: 'emSelecttable',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: { default: '' },
        displayValue: { default: '' },
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },

    data() {
        return {
            options: [],
            selectorShow: false,
            radiolistHeight: 0,
            currentValue: this.value,
            searchKey: ''
        };
    },

    computed: {
        param() {
            return this.model.initParam;
        },
        valueMember() {
            return this.param.valueMember || 'id';
        },
        displayMember() {
            return this.param.valueMember || 'name';
        },

        placeholder() {
            if (this.param.placeholder) {
                return this.param.placeholder;
            }
            return '请输入关键字';
        }
    },

    watch: {
        value(val) {
            this.currentValue = val;
        },
        selectorShow(val) {
            if (val) {
                this.radiolistHeight = document.documentElement.clientHeight - 44;
            }
        },
        searchKey: debounce(function(val) {
            if (val) {
                this.queryData(val);
            } else {
                this.options = [];
            }
        }, 200)
    },

    methods: {
        handleDisplayClick() {
            this.selectorShow = true;
        },
        handleClickSelect(row) {
            this.$emit('input', row[this.valueMember]);
            this.$emit('update:displayValue', row[this.displayMember]);
            history.back();
        },
        queryData(val) {
            let query = {};
            if (this.enableQuerySetting) {
                var querySetting = [];
                if (this.param.searchMember && this.param.searchMember.length > 0) {
                    this.param.searchMember.map(function(item) {
                        querySetting.push({
                            'name': item,
                            'value': val,
                            'linkOpt': 'OR',
                            'builder': 'include'
                        });
                    });
                }
                query.querySetting = JSON.stringify(querySetting);
            } else {
                query.queryopt = val;
            }
            query.pageSize = 10;
            query.pageNumber = 1;
            if (this.param.formatData) {
                query = this.param.formatData(query);
            }
            MINT.Indicator.open();
            queryData(this.model.url, query).then((rows) => {
                this.options = rows;
                MINT.Indicator.close();
            }, () => {
                MINT.Indicator.close();
            });
        }
    },

    components: {
        bsTransitionPage
    }
};
</script>
<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// emSelecttable.vue?1fbadbe6